import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InspectionService } from '../../../inspection.service';

@Component({
  selector: 'app-add-journal-entry-modal',
  templateUrl: './add-journal-entry-modal.component.html',
  styleUrls: ['./add-journal-entry-modal.component.scss'],
})
export class AddJournalEntryModalComponent implements OnInit {
  @Input() inspectionId: number;
  @Input() editNote: any = null;
  @Output() closeModal = new EventEmitter<void>();
  @Output() entryCreated = new EventEmitter<any>();
  @Output() entryUpdated = new EventEmitter<any>();

  form: FormGroup;
  isSaving = false;

  get isEditMode(): boolean {
    return !!this.editNote;
  }

  constructor(
    private fb: FormBuilder,
    private inspectionService: InspectionService,
  ) {
    this.form = this.fb.group({
      note: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    if (this.editNote) {
      this.form.patchValue({ note: this.editNote.note || '' });
    }
  }

  onCancel(): void {
    this.closeModal.emit();
  }

  async onSave(): Promise<void> {
    if (this.isSaving || this.form.invalid) return;
    this.isSaving = true;
    try {
      if (this.isEditMode) {
        const updatedNote = await this.inspectionService.updateNote(this.inspectionId, this.editNote.id, {
          reason: this.editNote.reason || 'Journal',
          content: this.form.get('note')?.value,
        });
        this.entryUpdated.emit({ ...this.editNote, ...updatedNote, content: this.form.get('note')?.value });
      } else {
        const formData = {
          reason: 'Journal',
          content: this.form.get('note')?.value,
        };
        const createdNote = await this.inspectionService.createNote(this.inspectionId, formData);
        this.entryCreated.emit(createdNote);
      }
      this.form.reset();
    } catch (error) {
      console.error('Error saving journal entry:', error);
    } finally {
      this.isSaving = false;
    }
  }

  onTextareaInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }
}
